<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div class="card">
        <div class="card-title">
          <strong></strong>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <h3>Relatório de Posições</h3>
            </div>
            <div class="col-md-6 text-right">
              
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <strong>Data: </strong>{{dadosRelatorios.data}}
                </div>
                <div class="col-md-3">
                  <strong>Veículo: </strong> {{dadosRelatorios.veiculo}}
                </div>
                <div class="col-md-5">
                  <strong>Empresa: </strong>{{dadosRelatorios.empresa}}
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <strong>Distância Percorrida: </strong>{{formatarVelocidade(dadosRelatorios.distanciaPercorrida)}} Km
                </div>
                <div class="col-md-3">
                  <strong>Velocidade Média: </strong>{{formatarVelocidade(dadosRelatorios.velocidadeMedia)}} Km/h
                </div>
                  <div class="col-md-5">
                  <strong>Velocidade Máxima: </strong>{{formatarVelocidade(dadosRelatorios.velocidadeMaxima)}} Km/h
                </div>
              </div>
            </div>
          </div>
          
          <template v-if="dadosRelatorios.dados.length > 0">
            <table class="table table-responsive-sm table-hover table-outline mb-0">
              <thead class="thead-light">
                <tr>
                  <th width="80">HORA</th>
                  <th>PONTO MAIS PROXIMO</th>
                  <th width="120">VELOCIDADE</th>
                  <th width="120">DESLOCAMENTO</th>
                  <th width="65">IGNIÇÃO</th>
                  <th width="50">GPS</th>
                  <th width="50">GPRS</th>
                  <th width="50">MOV</th> 
                  <th width="50">VOLT</th>
                  <th width="70">MOT T</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(dados, i) in dadosRelatorios.dados" @click="selecionarItem(dados)">
                  <td>
                    <input :id="'latitude_'+i" type="hidden" v-model="dados.latitude" />
                    <input :id="'longitude_'+i" type="hidden" v-model="dados.longitude" />
                    <small class="text-muted">{{dados.hora}}</small></td>
                  <td><small class="text-muted">{{dados.pontoMaisProximo}}</small></td>
                  <td><small class="text-muted">{{formatarVelocidade(dados.velocidade)}} Km/h</small></td>
                  <td><small class="text-muted">{{dados.deslocamento}} Km</small></td>
                  <td>
                    <template v-if="dados.ignicao">
                      <img src="/static/images/true.png" />
                    </template>
                    <template v-else>
                      <img src="/static/images/false.png" />
                    </template>
                  </td>
                  <td>
                    <template v-if="dados.gps">
                      <img src="/static/images/true.png" />
                    </template>
                    <template v-else>
                      <img src="/static/images/false.png" />
                    </template>
                  </td>
                  <td>
                    <template v-if="dados.gprs">
                      <img src="/static/images/true.png" />
                    </template>
                    <template v-else>
                      <img src="/static/images/false.png" />
                    </template>
                  </td>
                  <td>
                    <template v-if="dados.movimento">
                      <img src="/static/images/true.png" />
                    </template>
                    <template v-else>
                      <img src="/static/images/false.png" />
                    </template>
                  </td>
                  <td><small class="text-muted">{{dados.tensao}}</small></td>
                  <td><small class="text-muted">{{dados.motivoTransmissao}}</small></td>
                </tr>
              </tbody>
              
            </table>
          </template>          
          <template v-else>
            <div id="relatorio-sem-dados">
              <h1><bold>Sem dados para o período</bold></h1>
            </div>
          </template>
        </div>
      </div> 
    </div>                               
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false
    }
  },
  mounted () {
    this.buscarRelatorio()
  },
  methods: {
    selecionarItem: function (item) {
      console.log(item.id)
      this.selecionada = item.idVeiculo
    },
    selecionado: function (item) {
      return this.selecionada === item.idVeiculo
    },
    buscarRelatorio: function () {
      var self = this
      self.processando = true
      var veiculoId = this.$route.params.veiculo
      var dataHoraInicial = this.$route.params.dataHoraInicial
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/')
      var dataHoraFinal = this.$route.params.dataHoraFinal
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/')
      var filtroVelocidade = this.$route.params.filtroVelocidade
      var desprezarVelocidade = this.$route.params.desprezarVelocidade
      var agruparPosicoes = this.$route.params.agruparPosicoes
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/relatorios/relatorioDePosicoes?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosRelatorios = dadosCadastro
        self.processando = false
      })
    }
  }
}
</script>
}
</script>




// WEBPACK FOOTER //
// src/components/views/relatorios/RelatorioDeTempoForaHorarioTrabalhoView.vue